import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next'

import PlusIcon from '../../assets/icons/plus-icon.svg'
import { baseButtonTextWhiteBg } from '../../theme/custom-styles'

const ActionsBar = ({ handleOpenNewBankAccountModal }: { handleOpenNewBankAccountModal: () => void }) => {
  const { t } = useTranslation(['bank-accounts-management'])

  return (
    <div className="bank-accounts-management-actions-bar-container">
      <div className="bank-accounts-management-actions-bar-title">{t('actionsBar.title')}</div>
      <div className="users-management-actions-bar-button-action-container">
        <Button
          fullWidth
          variant="text"
          sx={baseButtonTextWhiteBg}
          startIcon={
            <img
              src={PlusIcon}
              alt="plus-icon"
            />
          }
          className="users-management-actions-bar-button-action"
          onClick={handleOpenNewBankAccountModal}
        >
          <div className="users-management-actions-bar-button-action-text">{t('actionsBar.buttonsTexts.addAccount')}</div>
        </Button>
      </div>
    </div>
  )
}

export default ActionsBar
